import { PageEditMode } from './page-edit-mode';
import { PageEditModeStatus } from './page-edit-mode-status';
import { Page } from '../../models/page';
import { PageComponent } from '../../components/bookviewer/page/page.component';
import { ScrollPageComponent } from '../../components/bookviewer/scroll-page/scroll-page.component';
import { PageDrawing } from '../../models/page-drawing';

export class DrawEditMode implements PageEditMode {

    status: PageEditModeStatus;
    pageDrawing: PageDrawing;
    pageComponent: PageComponent | ScrollPageComponent;
    type = 'DRAW';

    constructor(pageDrawing: PageDrawing) {
        this.pageDrawing = pageDrawing;
    }

    getPage(): Page {

        if (!this.pageComponent) {
            return undefined;
        }

        return this.pageComponent.page;
    }

    getResult(): any {
        return this.pageDrawing;
    }

    getStatus(): PageEditModeStatus {
        return undefined;
    }

    onMouseDown($event): void {
        if (this.status === PageEditModeStatus['PENDING']) {
            return;
        }

        this.status = PageEditModeStatus['PENDING'];
    }

    onMouseLeave($event): void {
        // nothing to do
    }

    onMouseMove($event): void {
        // nothing to do
    }

    onMouseUp($event): void {
        // nothing to do
    }

    onPinch($event): void {
        // nothing to do
    }

    setPage(pageComponent: PageComponent | ScrollPageComponent): void {
        this.pageComponent = pageComponent;
    }

}
